import { canv } from "@/canv/global";
import { Group } from "@/group";
import { VirtualCursor } from "@/multiManager/VirtualCursor";

interface SelectedProps {
    startX: number;
    startY: number;
    width: number;
    height: number;
}

export class MultiUser {
    name: string;
    login: string;
    sessionUID: string;
    token?: string;
    color: string;
    virtualCursor: VirtualCursor;
    viewData: Record<string, any> = {};

    selectedGroups: any[] = [];
    selectedGroupsStartX = 0;
    selectedGroupsStartY = 0;
    selectedGroupsWidth = 0;
    selectedGroupsHeight = 0;

    constructor(
        name: string,
        login: string,
        sessionUID: string,
        token: string | undefined,
        color: string,
    ) {
        this.name = name === "" ? "Guest" : name;
        this.login = login;
        this.sessionUID = sessionUID;
        this.token = token;
        this.color = color;
        this.virtualCursor = new VirtualCursor(this.name, this.color);
    }

    updateVirtualCursor(x: number, y: number): void {
        this.virtualCursor.updatePosition(x, y);
    }

    changeVisibility(isVisible: boolean): void {
        isVisible ? this.virtualCursor.show() : this.virtualCursor.hide();
    }

    updateViewData(data: Record<string, any>): void {
        this.viewData = data;
    }

    setSelectedGroups(selectedGroupsUIDs: string[]): void {
        this.selectedGroups = [];

        for (const uid of selectedGroupsUIDs) {
            const item = canv.canvasController.FindByUID(uid);
            if (!item || !(item instanceof Group)) continue;

            const child = item.onlyChild();

            if (
                item.isItemWrapper() &&
                (child?.constructorName === "mindMap" || child?.constructorName === "table")
            ) {
                continue;
            }

            this.selectedGroups.push(item);
        }

        this.calcOutline();
    }

    draw(): void {
        this.calcOutline();
        this.showOutline();
        this.virtualCursor.draw();
    }

    private calcOutline(): void {
        if (this.selectedGroups.length === 0) return;

        const dims: SelectedProps = canv.canvasController.getSelectedProps(this.selectedGroups);
        this.selectedGroupsStartX = dims.startX;
        this.selectedGroupsStartY = dims.startY;
        this.selectedGroupsWidth = dims.width;
        this.selectedGroupsHeight = dims.height;
    }

    private showOutline(): void {
        if (this.selectedGroups.length === 0) return;

        canv.ctx.save();
        canv.ctx.strokeStyle = this.color;
        canv.ctx.lineWidth = canv.actionManager.getZoomConstant(2.5);
        canv.ctx.strokeRect(
            this.selectedGroupsStartX - 5,
            this.selectedGroupsStartY - 5,
            this.selectedGroupsWidth + 10,
            this.selectedGroupsHeight + 10,
        );
        canv.ctx.restore();
    }
}
